import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { IReckonHotelEffects } from './integrated-ireckon-hotel.effects';
import { integratedIReckonHotelReducer } from './integrated-ireckon-hotel.reducer';

export const provideIntegratedIReckonHotelStore = () => [
  provideState('integratedIReckonHotel', integratedIReckonHotelReducer),
  provideEffects([IReckonHotelEffects]),
];
